import React from 'react';
import Title from '../../partials/title';
import { Link } from 'react-router';

// August 6th: refactored for responsiveness
const Communication = () => {
    return (
        <div className="w3-container w3-content pt-8 pb-8">
            <div className="d-flex row-column">
                <div className="w-100">
                    <Title text="Communication" className="white" />
                    <p className="white margin-top hind">All Challenge Sports Tournaments use the Sports Logic System for fast, comprehensive communication. All SCHEDULES and RESULTS will be posted on the Challenge Sports Site or the Sports Logic System. For more information contact Challenge Sports by email at info@challengesports.com</p>
                </div>
                <div style={{ width: 20, height: 20 }} />
                <Link to="/contact" className="btn-transparent text-center align-self-center">CONTACT US</Link>
            </div>
        </div>
    );
}

export default Communication;



// WEBPACK FOOTER //
// ./src/components/information/partials/communication.js